import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Logo, GoldButton } from "./ui";
import { useAuth } from "@/context/AuthContext";

const NAV = [
    { label: "Discover", to: "/opportunities" },
    { label: "Brands", to: "/brands" },
    { label: "Experts", to: "/experts" },
    { label: "Influencers", to: "/influencers" },
    { label: "Podcasts", to: "/podcasts" },
    { label: "Events", to: "/events" },
];
const MARKETING = [
    ["Digital Marketing", "/marketing/digital-marketing"], ["Social Media", "/marketing/social-media"],
    ["Performance Marketing", "/marketing/performance-marketing"], ["SEO", "/marketing/seo"],
    ["Google Ads", "/marketing/google-ads"], ["Meta Ads", "/marketing/meta-ads"],
    ["Content Marketing", "/marketing/content-marketing"], ["Influencer Marketing", "/marketing/influencer-marketing"],
    ["Reels & Video", "/marketing/reels"], ["Branding", "/marketing/branding"],
    ["Website & Landing Pages", "/marketing/website"], ["Lead Generation", "/marketing/lead-generation"],
    ["PR & Media", "/marketing/pr-media"],
];

export function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [mkOpen, setMkOpen] = useState(false);
    const { user } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    useEffect(() => { setOpen(false); setMkOpen(false); }, [loc.pathname]);

    const dashLink = user && user.role !== "customer" ? (user.role === "bde" ? "/bde" : user.role === "organiser" ? "/organiser" : "/admin") : user ? "/account" : "/login";

    return (
        <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "glass border-b border-brandborder/60 py-2.5" : "bg-transparent py-4"}`}>
            <nav className="container-x flex items-center justify-between">
                <Logo />
                <div className="hidden lg:flex items-center gap-6">
                    {NAV.map((n) => (
                        <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                            className={`text-sm font-medium transition-colors hover:text-gold ${loc.pathname === n.to ? "text-gold" : "text-cream-soft"}`}>{n.label}</Link>
                    ))}
                    <div className="relative" onMouseEnter={() => setMkOpen(true)} onMouseLeave={() => setMkOpen(false)}>
                        <button className="text-sm font-medium text-cream-soft hover:text-gold flex items-center gap-1" data-testid="nav-marketing">Marketing Solutions <ChevronDown className="w-3.5 h-3.5" /></button>
                        {mkOpen && (
                            <div className="absolute top-full right-0 pt-3">
                                <div className="glass border border-brandborder rounded-2xl p-2 grid grid-cols-2 gap-1 w-[30rem]">
                                    {MARKETING.map(([label, to]) => (
                                        <Link key={to} to={to} className="px-3 py-2 rounded-lg text-sm text-cream-soft hover:bg-teal-700/50 hover:text-gold" data-testid={`nav-mk-${to.split("/").pop()}`}>{label}</Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <Link to="/community" className={`text-sm font-medium hover:text-gold ${loc.pathname === "/community" ? "text-gold" : "text-cream-soft"}`} data-testid="nav-community">Community</Link>
                </div>
                <div className="hidden lg:flex items-center gap-3">
                    <Link to="/messages" data-testid="nav-messages" className="text-sm font-medium text-cream-soft hover:text-gold">Messages</Link>
                    <Link to={dashLink} data-testid="nav-account" className="text-sm font-medium text-cream-soft hover:text-gold">{user ? "Dashboard" : "Login"}</Link>
                    <GoldButton as={Link} to="/build-my-brand" data-testid="nav-join" className="!py-2.5">Join SuDigi</GoldButton>
                </div>
                <button className="lg:hidden text-cream p-2" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle" aria-label="Menu">{open ? <X /> : <Menu />}</button>
            </nav>
            {open && (
                <div className="lg:hidden container-x mt-3 glass rounded-2xl border border-brandborder/60 p-4 space-y-1 max-h-[75vh] overflow-y-auto" data-testid="mobile-menu">
                    {NAV.map((n) => <Link key={n.to} to={n.to} className="block py-2.5 px-2 text-cream-soft hover:text-gold font-medium">{n.label}</Link>)}
                    <Link to="/community" className="block py-2.5 px-2 text-cream-soft hover:text-gold font-medium">Community</Link>
                    <div className="pt-2 border-t border-brandborder/50"><div className="px-2 py-1 text-xs text-gold font-semibold uppercase">Marketing Solutions</div>
                        {MARKETING.map(([label, to]) => <Link key={to} to={to} className="block py-2 px-2 text-sm text-cream-soft hover:text-gold">{label}</Link>)}
                    </div>
                    <Link to={dashLink} className="block py-2.5 px-2 text-cream-soft hover:text-gold font-medium">{user ? "Dashboard" : "Login"}</Link>
                    <GoldButton className="w-full mt-2" onClick={() => nav("/build-my-brand")}>Join SuDigi</GoldButton>
                </div>
            )}
        </header>
    );
}
